import {
  type StorefrontFeatureKey,
  type StorefrontNavLink,
  type StorefrontNavPlace,
  type StorefrontTerminology,
  visibleStorefrontNavLinks,
} from "@loot-os/api-contract";
import { NAV_ICONS } from "@loot-os/design-system/templates/shared/navIcons";
import type { IconData } from "@loot-os/icons/types";

/**
 * Where a link can appear: the header's links, the phone's tab bar, the signed-in shopper's
 * account menu and the footer's Store column.
 */
export type NavPlace = StorefrontNavPlace;

/** A link as the header, the menu, the tab bar and the footer render it, in the store's words. */
export interface NavLink extends StorefrontNavLink {
  icon: IconData;
}

export function visibleNavItems(
  hasFeature: (key: StorefrontFeatureKey) => boolean,
  terms: StorefrontTerminology,
): NavLink[] {
  return visibleStorefrontNavLinks(hasFeature, terms).map((link) => ({
    ...link,
    icon: NAV_ICONS[link.to],
  }));
}

/** The visible links that appear in `place`, in `STOREFRONT_NAV_LINKS` order. */
export function navLinksIn(links: readonly NavLink[], place: NavPlace): NavLink[] {
  return links.filter((link) => link.places.includes(place));
}
